import {Routes} from '@angular/router';

import {NotFoundComponent} from './not-found/not-found.component';
import {LogoutComponent} from '../Elements/logout/logout.component';
import {HomeComponent} from './home/home.component';
import {TermsComponent} from './terms/terms.component';
import {MobileApplicationModule} from './mobile-application/mobile-application.module';
import {LoginComponent} from './login/login.component';
import {IndividualAccidentsModule} from './individual-accidents/individual-accidents.module';
import {QuestionsComponent} from './questions/questions.component';
import {RoleGuard} from '../services/guards/role-guard.service';
import {ZarinpalComponent} from './zarinpal/zarinpal.component';
import {ProfileComponent} from './profile/profile.component';
import {NotesComponent} from './notes/notes.component';
import {MyRequestsComponent} from './my-requests/my-requests.component';
import {InvoiceComponent} from './invoice/invoice.component';

export const appRoutes: Routes = [
  {path: 'mobile', loadChildren: () => MobileApplicationModule},
  {
    path: '', 
    redirectTo:'health/family',
    pathMatch: 'full'
  },
  {
    path: 'invoice/:productName/:requestID', component: InvoiceComponent,
    pathMatch: 'full'
  },
  {
    path: ':productName/forms',
    component: QuestionsComponent,
    canActivate: [RoleGuard],
    data: {role: 'user'}
  },
  {
    path: 'health/family',
    loadChildren: () => import('./health-family-application/health-family-application.module')
      .then(m => m.HealthFamilyApplicationModule)
  },
  {
    path: 'PET',
    loadChildren: () => import('./pet-application/pet-application.module')
      .then(m => m.PetApplicationModule)
  },
  {
    path: 'HEALTH_GROUP',
    loadChildren: () => import('./health-group-application/health-group-application.module')
      .then(m => m.HealthGroupApplicationModule)
  },
  {
    path: 'insurance-service',
    loadChildren: () => import('./insurance-service/introduction-letter.module')
      .then(m => m.IntroductionLetterModule)
  },
  {
    path: 'external-employee',
    loadChildren: () => import('./external-employee-application/external-employee-application.module')
      .then(m => m.ExternalEmployeeApplicationModule)
  },
  {path: 'individual-accidents', loadChildren: () => IndividualAccidentsModule},
  {path: 'logout', component: LogoutComponent},
  {
    path: 'profile', component: ProfileComponent,
    canActivate: [RoleGuard],
    data: {role: 'user'}
  },
  {
    path: ':productName/requests', component: MyRequestsComponent,
    canActivate: [RoleGuard],
    data: {role: 'user'}
  },
  {
    path: 'notes/:productName/:requestID', component: NotesComponent,
    canActivate: [RoleGuard],
    data: {role: 'user'}
  },
  {path: 'zarinpal/:productName', component: ZarinpalComponent},
  // {path: 'about-us', component: AboutUsComponent},
  {path: 'login', component: LoginComponent},
  {path: 'terms', component: TermsComponent},
  {path: '**', component: NotFoundComponent}
];
